import React, { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import { Stack } from "react-bootstrap";
import { filesService } from "../services";

const UploadButton: React.FC<{
  refreshFileList: () => void;
}> = ({ refreshFileList }) => {
  const fileSelector = useRef<HTMLInputElement>(null);
  const [msg, setMsg] = useState<string>();
  const [showProgessDialog, setShowProgressDialog] = useState<boolean>(false);
  const [showFolderNameDialog, setShowFolderDialog] = useState<boolean>(false);
  const [newFolderName, setNewFolderName] = useState<string>("");
  const handleFiles = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    if (event.target.files) {
      try {
        setMsg("Fetching upload URL...");
        setShowProgressDialog(true);
        const uploadUrl = await filesService.getUploadUrl(
          event.target.files[0]
        );
        setMsg(`Uploading ${event.target.files[0].name}...`);
        const result = filesService.uploadFile(
          event.target.files[0],
          uploadUrl
        );
        setMsg(await result);
      } catch (e) {
        console.log(e);
        setMsg("Error");
      }
    }
  };
  const createNewFolder = async () => {
    await filesService.createNewFolder(newFolderName);
    await refreshFileList();
    setShowFolderDialog(false);
  };
  return (
    <>
      <Modal
        show={showProgessDialog}
        onHide={() => {
          setShowProgressDialog(false);
          refreshFileList();
        }}
        centered
      >
        <Modal.Header closeButton>Uploading File...</Modal.Header>
        <Modal.Body>{msg}</Modal.Body>
      </Modal>
      <Modal
        show={showFolderNameDialog}
        onHide={() => setShowFolderDialog(false)}
      >
        <Modal.Header closeButton>Add Folder</Modal.Header>
        <Modal.Body>
          <Stack gap={3}>
            <FormControl
              onChange={(e) => setNewFolderName(e.target.value)}
              value={newFolderName}
              placeholder="Enter folder name"
            />
          </Stack>
          <Button
            disabled={newFolderName.length === 0}
            onClick={() => createNewFolder()}
          >
            Create Folder
          </Button>
        </Modal.Body>
      </Modal>
      <FormControl
        hidden={true}
        ref={fileSelector}
        type="file"
        onChange={handleFiles}
      />
      {/* <Button onClick={() => fileSelector.current?.click()}>Upload</Button> */}
      <Dropdown>
        <Dropdown.Toggle>Add</Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => fileSelector.current?.click()}>
            Upload file
          </Dropdown.Item>
          <Dropdown.Item onClick={() => setShowFolderDialog(true)}>
            Add folder
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default UploadButton;
